import { ApiSet, BaseResponse, IndexApiSet, useDeleteApi, useIndexApi, usePostApi, usePutApi } from 'utils/network/api_hooks'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { GroupTraining, GroupTrainingForm, GroupTrainingLedgerSearchForm } from 'entities/group_training'

type GroupTrainingLedgerResponse = PagingResponse & {
    results: GroupTraining[]
}

export function useFetchGroupTrainingLedgerApi(
    searchForm?: Form<GroupTrainingLedgerSearchForm>
): IndexApiSet<GroupTrainingLedgerResponse> & { execute: () => void } {
    const apiPath = 'group_training_ledgers/'
    const api = useIndexApi<GroupTrainingLedgerResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
    })

    const execute = (): void => {
        api.execute(apiPath, { params: searchForm?.object })
    }

    useEffectSkipFirst(() => {
        execute()
    }, [api.pageSet.page, api.pageSet.perPage])

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm?.object])

    return { ...api, execute: execute }
}

export function usePostGroupTrainingLedgerApi(): ApiSet<BaseResponse> & { execute: (form: Form<GroupTrainingForm>) => void } {
    const apiSet = usePostApi<BaseResponse, GroupTrainingForm>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<GroupTrainingForm>) => {
        const apiPath = `group_training_ledgers/`
        apiSet.execute(apiPath, form)
    }

    return { ...apiSet, execute: execute }
}

export function usePutGroupTrainingLedgerApi(): ApiSet<BaseResponse> & { execute: (form: Form<GroupTrainingForm>) => void } {
    const apiSet = usePutApi<BaseResponse, GroupTrainingForm>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<GroupTrainingForm>) => {
        const apiPath = `group_training_ledgers/${form.object.id}/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function useBulkPutGroupTrainingLedgerApi(): ApiSet<BaseResponse> & { execute: (form: Form<GroupTrainingForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, GroupTrainingForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<GroupTrainingForm[]>) => {
        const apiPath = `group_training_ledgers/bulk_update/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function useDeleteGroupTrainingLedgerApi(): ApiSet<BaseResponse> & {
    execute: (id: number) => void
} {
    const api = useDeleteApi<BaseResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (id: number): void => {
        const apiPath = `group_training_ledgers/${id}/`
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}
